import Vue from "vue";
import vueMoment from "vue-moment";
const moment = require("moment");

Vue.use(vueMoment, {
  moment
});
